module.exports = __webpack_public_path__ + "static/img/navLogo.0db5c40d.png";